import styled from "styled-components";

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0;
`;

export const SearchContainer = styled.div`
  flex: 1;
  margin-right: 16px;

  display: flex;

  > div:first-child {
    // Cannot style the Input directly.
    margin-top: 0;
    margin-right: 4px;
  }
`;
